import { defineMeta } from '@/registry/types';

export const badgeMeta = defineMeta({
  name: 'Badge',
  level: 'atom',
  category: 'data-display',
  classification: 'themed-mui',
  description: 'Small count or status indicator anchored to another element. Themed MUI Badge.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Badge',
  muiDocs: 'https://mui.com/material-ui/react-badge/',
  a2uiEquivalent: 'Badge',
  importPath: '@/atoms/Badge',
  optionalProps: ['badgeContent', 'color', 'variant', 'max', 'showZero', 'overlap'],
  supportedStates: ['count', 'dot', 'zero', 'max'],
  designTokens: ['colors'],
  accessibility: ['Ensure the count is conveyed to screen readers via the wrapped control label.'],
  usageExamples: ['<Badge badgeContent={4} color="error"><NotificationsIcon /></Badge>'],
  antiPatterns: ['Do not place long text in a Badge (use Chip).'],
  llmSafe: true,
  whenToUse: ['Unread counts, notification dots, status'],
  whenNotToUse: ['Standalone labels (use Chip)'],
});

export default badgeMeta;
